<template>
    <div>
        <ongoing @done="addToPast"></ongoing>
        <div style="margin-top: 6px;margin-bottom: 6px">
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-divider></v-divider>
        </div>
        <past ref="past_rides"></past>
    </div>
</template>

<script>
    import Ongoing from "@/components/monitoring/Ongoing";
    import Past from "@/components/monitoring/Past";

    export default {
        name: "RidesTracking",
        title() {
            return this.$t("monitoring.ridesTracking.title");
        },
        components: {Ongoing, Past},
        data() {
            return {};
        },
        mounted() {
        },
        methods: {
            addToPast(elem) {
                this.$refs.past_rides.add(elem);
            }
        }
    }
</script>

<style scoped>

</style>`